export default class Building {
  constructor(id, address, forRent, imageURL, name) {
    this.id = id;
    this.address = address;
    this.forRent = forRent;
    this.imageURL = imageURL;
    this.name = name;
  }
}
